import React from 'react'
import './Testimonial.css'
import{Swiper, SwiperSlide} from 'swiper/react'
import { Pagination } from 'swiper'
import 'swiper/css/pagination'
import 'swiper/css'
import { useContext } from "react";
import { themeContext } from '../../Context';

const Testimonial = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    /*Making an ARRAY OF CLIENTS*/
    const clients = [
        {
            review:
            "Working with Benjamin was a pleasure. Their attention to detail and creativity were invaluable in bringing our project to life. We look forward to working with them again in the future. - Chris"
        },
        {
            review:
            "I was impressed by Teamsske's ability to take our vision and turn it into a beautiful and functional website. Their communication throughout the process was excellent and they delivered the project on time and within budget. - Monique"
        },
        {
            review:
            "I highly recommend Teamsske for any 3D work. They have a keen eye for aesthetics and their work is always top-notch. They are also a pleasure to work with and always go the extra mile to ensure client satisfaction. - Phil"
        },
        {
            review:
            "I have worked with Benny on several projects and have always been impressed by his professionalism, skill, and attention to detail. He is a valuable asset to any team and I look forward to working with them again in the future. - Nik Alexander"
        },
        {
            review:
            "One of the best freelancers i’ve come across on Upwork. At first it was a small task but Lammy has went the very extra miles to double the amount of work he wants to give me AND gets it done proficiently in no-time. I’m glad to have worked with you and will definitely hire again. Highly recommended - Upwork",
        },
        {
            review:
            "Great work as always. We work with him on a great number of our projects where his 3D skills bring everything to life. -Upwork"
        }
    ]

  return (
    <div className="t-wrapper" id='Testimonial'>
        <div className="t-heading">
            <span>Client always recieve</span>
            <span>Excellent Services</span>
            <span>From me...</span>
            <div className="blur t-blur1"  style={{background: "var(--purple)"}}></div>
            <div className="blur t-blur2"  style={{background: "#C1F5FF"}}></div>
        </div>

    {/*slider*/}

    <Swiper
    modules={[Pagination]}
    slidesPerView={1}
    pagination = {{clickable: true}}
    >
        {clients.map((clients,index) =>{
            return(
                <SwiperSlide key={index}>
                    <div className="testimonial">
                    <span style = {{color : darkMode? 'white': ''}}>{clients.review}</span>
                    </div>
                </SwiperSlide>
            )
        }
        )}
    </Swiper>

    </div>
  )
}

export default Testimonial